const latitude = [
    { type: 'required', message: 'Latitude is required' },
    { type: 'maxlength', message: 'Latitude must be 13 characters long' },
    { type: 'minlength', message: 'Latitude must be 13 characters long' },
    { type: 'pattern', message: 'Your latitude must be of this format: 25.3007394343' }
]

export default { latitude }